module.exports = __webpack_public_path__ + "static/media/wheelchair.9e367b86.svg";